import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-chart-statistic',
  templateUrl: './chart-statistic.component.html',
  standalone: false
})
export class ChartStatisticComponent implements OnInit {
  @Input() values: any;
  @Input() legend!: boolean;
  @Input() showYAxis!: boolean;
  @Input() xAxisLabel!: string;
  @Input() yAxisLabel!: string;
  @Input() type = 'bar';
  @Input() isDoughnut!: boolean;
  @Input() colorScheme: any;
  @Input() key!: string;
  @Input() legendPosition: any = 'right';
  @Input() arcWidth: number = 0.25;
  @Output() filterChart = new EventEmitter<any>();

  multi!: any[];

  view: any[] = [];

  // options
  showXAxis = true;
  gradient = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  legendTitle = '';
  showLabels = true;

  constructor(private router: Router) {
    Object.assign(this, { ...this.values });
  }

  ngOnInit() {
  }

  formatDataLabel(value: any) {
    const self: any = this; // this "this" will refer to the chart component (pun intented :))
    const item = self.series.filter((data: any) => data.name === value);
    if (item.length > 0) {
      return item[0].extra.label;
    }
    return value;
  }

  onResize(event: any) {
    this.view = [event.target.innerWidth, 400];
  }

}
